const options = {
  5: "bg-zinc-50/5",
  10: "bg-zinc-50/10",
  25: "bg-zinc-50/25",
  50: "bg-zinc-50/50",
  75: "bg-zinc-50/75",
  90: "bg-zinc-50/90",
  100: "bg-zinc-50",
};

const from = {
  5: "from-zinc-50/5",
  10: "from-zinc-50/10",
  25: "from-zinc-50/25",
  50: "from-zinc-50/50",
  75: "from-zinc-50/75",
  90: "from-zinc-50/90",
  100: "from-zinc-50",
};

export default function getBackgroundZinc50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
